import _Textarea from './Textarea';
import _Checkbox from './Checkbox';
import _FileInput from './FileInput';
import _Radio from './Radio';
import _Input from './Input';

export const Textarea = _Textarea;
export const Checkbox = _Checkbox;
export const FileInput = _FileInput;
export const Radio = _Radio;
export const Input = _Input;


// WEBPACK FOOTER //
// ./src/components/Input/index.js